/* eslint-disable no-unused-vars */
import { useContext, useEffect, useState } from 'react'
import { Offcanvas, Button, Form } from 'react-bootstrap'
import { Key, LogOut, Building2 } from 'lucide-react'
import api from '../../config/AxiosInstance'
import { UserContext } from '../../context/userContext'
import styles from './dashboard.module.css'
import toast from 'react-hot-toast'

function DrawerChangeWarehouse(props) {
  const [state, dispatch] = useContext(UserContext)

  const {
    showCanvasWarehouse,
    handleCloseCanvasWarehouse,
    setShowModalChangePassword,
    handleLogOut
  } = props
  const [warehousesData, setWarehousesData] = useState([])
  const [selectedWarehouses, setSelectedWarehouses] = useState([])

  useEffect(() => {
    fetchWarehouses()
  }, [])

  useEffect(() => {
    if (showCanvasWarehouse && warehousesData.length > 0) {
      const initialSelected = warehousesData
        .filter((w) => w.is_selected)
        .map((w) => w.warehouse_id)
      setSelectedWarehouses(initialSelected)
    }
  }, [showCanvasWarehouse, warehousesData])

  const handleCheckboxChange = (warehouseId) => {
    setSelectedWarehouses((prev) => {
      if (prev.includes(warehouseId)) {
        return prev.filter((id) => id !== warehouseId)
      } else {
        return [...prev, warehouseId]
      }
    })
  }

  const handleSave = async () => {
    try {
      const res = await api.post('users/change-warehouse', {
        warehouse_ids: selectedWarehouses
      })
      const { data } = res

      if (data.success) {
        const keyUser = JSON.parse(localStorage.getItem('username'))
        const newKeyUser = {
          ...keyUser,
          warehouse_active: selectedWarehouses
        }

        dispatch({
          type: 'updateWarehouseActive',
          payload: newKeyUser
        })
        handleCloseCanvasWarehouse()
        window.location.reload()
      }
    } catch (error) {
      const err = error?.response?.data?.errors?.message || 'An error occurred'
      toast.error(err, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    }
  }

  const fetchWarehouses = async () => {
    try {
      const res = await api.get(
        '/master/warehouses/all?is_parent=true&forUser=1&showAll=true'
      )
      const { data } = res
      if (data.success) {
        setWarehousesData(data.data)
      }
    } catch (error) {
      const err = error?.response?.data?.errors?.message || 'An error occurred'
      toast.error(err, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    }
  }

  return (
    <>
      <Offcanvas
        show={showCanvasWarehouse}
        onHide={handleCloseCanvasWarehouse}
        placement="end"
        id="change-warehouse-drawer"
        className="border-0 shadow-lg"
        style={{ width: '400px' }}
      >
        <div className={styles.drawerHeader}>
          <h5 className={styles.drawerTitle}>User Settings</h5>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={handleCloseCanvasWarehouse}
          ></button>
        </div>

        <Offcanvas.Body className="p-0 d-flex flex-column">
          <div className={styles.drawerSection}>
            <p className={styles.sectionTitle}>Account</p>
            <div
              className={styles.menuItem}
              onClick={() => setShowModalChangePassword(true)}
            >
              <Key size={16} className={styles.menuIcon} />
              <span>Change Password</span>
            </div>
            <div
              className={`${styles.menuItem} ${styles.menuItemLogout}`}
              onClick={handleLogOut}
            >
              <LogOut size={16} className={styles.menuIcon} />
              <span>Sign Out</span>
            </div>
          </div>

          <div className={`${styles.drawerSection} flex-grow-1 overflow-auto`}>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <p className={styles.sectionTitle}>Switch Warehouse</p>
            </div>

            <div className={styles.warehouseList}>
              {warehousesData.length > 0 &&
                warehousesData.map((warehouse) => (
                  <div
                    key={warehouse.warehouse_id}
                    className={`${styles.warehouseItem} ${
                      selectedWarehouses.includes(warehouse.warehouse_id)
                        ? styles.warehouseItemActive
                        : ''
                    }`}
                    onClick={() => handleCheckboxChange(warehouse.warehouse_id)}
                    style={{ cursor: 'pointer' }}
                  >
                    <div className="d-flex align-items-center w-100">
                      <Form.Check
                        type="checkbox"
                        checked={selectedWarehouses.includes(
                          warehouse.warehouse_id
                        )}
                        className={`${styles.customCheckbox} me-2`}
                        id={`warehouse-${warehouse.warehouse_id}`}
                        onClick={(e) => e.stopPropagation()}
                        onChange={() =>
                          handleCheckboxChange(warehouse.warehouse_id)
                        }
                      />
                      <Building2 size={16} className={styles.warehouseIcon} />
                      <div className="flex-grow-1 ms-2">
                        <div className={styles.warehouseName}>
                          {warehouse.warehouse_name}
                        </div>
                        <div className={styles.warehouseId}>
                          ID: {warehouse.warehouse_id}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>

          <div className="p-3 border-top">
            <Button
              className={`w-100 ${styles.btnSave}`}
              onClick={handleSave}
              disabled={selectedWarehouses.length === 0}
            >
              Save Changes
            </Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  )
}

export default DrawerChangeWarehouse
